import { Button } from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import { ReactComponent as ERD } from "assets/svg/ERD.svg";
import { Currency } from "utils/numberFormat";
import { addToCart } from "../store/cartSlice";

const Foods = ({ title, foods }) => {
  const dispatch = useDispatch();

  const addItem = (food) => {
    const newCartItem = {
      id: food.id,
      food_name: food.food_name,
      price: food.price,
      quantity: 1,
    };

    dispatch(addToCart(newCartItem));
  };

  return (
    <div className="mt-4 w-full !bg-white rounded-md border overflow-hidden">
      <div className="bg-btnGreen-normal px-3.5 py-2 text-[15px] font-bold uppercase text-white">
        {title}
      </div>

      {foods.map((food) => (
        <div
          key={food.food}
          className="px-3.5 py-2.5 w-full flex flex-row items-center justify-between border-b"
        >
          <h5 className="font-semibold">{food.food_name}</h5>
          <div className="flex items-center gap-4">
            <h5 className="font-semibold">
              <Currency value={food.price} />
            </h5>
            <Button
              colorScheme="customGreen"
              px="0"
              onClick={() => addItem(food)}
            >
              <ERD style={{ width: "22px", height: "22px" }} />
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Foods;
